import formatNumber from 'App/i18n/formatNumber'
import isNumber from 'lodash/isNumber'

export default function(value) {
  if (!isNumber(value)) return ''

  const textValue = formatNumber(value, '0.[000000000000000000000]')
  return textValue
}
